import { createSlice } from '@reduxjs/toolkit'
import { MatchWithPredictions, RoomRanking } from '../types/match'

interface MatchesState {
  roomMatches: { [roomId: string]: MatchWithPredictions[] }
  rankings: { [roomId: string]: RoomRanking[] }
  isLoading: boolean
  error: string | null
}

const initialState: MatchesState = {
  roomMatches: {},
  rankings: {},
  isLoading: false,
  error: null,
}

export const matchesSlice = createSlice({
  name: 'matches',
  initialState,
  reducers: {
    setRoomMatches: (state, action) => {
      const { roomId, matches } = action.payload
      state.roomMatches[roomId] = matches
    },
    setRoomRankings: (state, action) => {
      const { roomId, rankings } = action.payload
      state.rankings[roomId] = rankings
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload
    },
    setError: (state, action) => {
      state.error = action.payload
    },
    updateMatchPrediction: (state, action) => {
      const { roomId, matchId, prediction } = action.payload
      if (state.roomMatches[roomId]) {
        const matchIndex = state.roomMatches[roomId].findIndex(match => match._id === matchId)
        if (matchIndex !== -1) {
          state.roomMatches[roomId][matchIndex].userPrediction = prediction
        }
      }
    },
    clearRoomData: (state, action) => {
      const roomId = action.payload
      delete state.roomMatches[roomId]
      delete state.rankings[roomId]
    },
  },
})

export const { 
  setRoomMatches, 
  setRoomRankings, 
  setLoading, 
  setError,
  updateMatchPrediction,
  clearRoomData
} = matchesSlice.actions

export default matchesSlice.reducer
